import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/PageHero";
import Seo from "@/components/Seo";
import { HERO_ART } from "@/lib/heroes";
import ForumList from "@/components/ForumList";
import InviteButton from "@/components/InviteButton";

export default function QnA() {
  const { pick } = useLang();
  return (
    <div data-testid="qna-page">
      <Seo path="/qna" title="Questions & Answers — Ask the Community"
        description="Ask questions about rituals, mantras, festivals, scriptures and practice — and receive answers from the community." />
      <PageHero art={HERO_ART.explainers} overline={pick("समुदाय · प्रश्न एवं उत्तर", "Community · Questions & Answers")}
        deva="प्रश्न एवं उत्तर" en={pick("प्रश्न एवं उत्तर", "Questions & Answers")}
        tagline={pick("अपने प्रश्न पूछें — विधि, मंत्र, व्रत, शास्त्र एवं साधना पर। समुदाय उत्तर देगा; सर्वोत्तम उत्तर चुनें।", "Ask your questions on ritual, mantra, vrata, scripture and sadhana. The community answers — and you can mark the best one.")} />
      <ForumList kind="qna" basePath="/qna" />
      <div className="mx-auto max-w-5xl px-5 pb-10 md:px-8"><InviteButton context={pick("प्रश्न एवं उत्तर", "Questions & Answers")} testid="qna-invite" /></div>
    </div>
  );
}
